import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const LoginPage = ({ data, grades }) => {
  const navigate = useNavigate();
  const [matchingId, setMatchingId] = useState(null);
  const [matchingPasscode, setMatchingPasscode] = useState(null);

  const [inputId, setInputId] = useState("");
  const [inputPasscode, setInputPasscode] = useState("");

  const handleInputId = (event) => {
    setInputId(event.target.value);
  };
  const handleInputPasscode = (event) => {
    setInputPasscode(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const inputIdAsNumber = parseInt(inputId);
      const foundId = data.find(
        (item) =>
          item.t1key110 === inputIdAsNumber ||
          item.t1key110 === String(inputIdAsNumber)
      );
      setMatchingId(foundId);
      const foundPasscode = data.find(
        (item) => item.t1key112 === inputPasscode
      );
      setMatchingPasscode(foundPasscode);
    };
    fetchData();
    return () => {
      setMatchingId(null);
      setMatchingPasscode(null);
    };
  }, [inputId, inputPasscode, data]);

  const handleButtonClick = () => {
    if (matchingId && matchingPasscode) {
      toast.success("Successfully logged in");
      navigate(`/grades/${matchingId.t1key110}`);
    } else if (matchingId && !matchingPasscode) {
      toast.error("Invalid Passcode");
    } else if (!matchingId && matchingPasscode) {
      toast.error("Invalid Id");
    } else {
      toast.error("Invalid Id and Passcode");
    }
  };

  const handleForgotPassword = () => {
    navigate("/forgot-passcode");
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <div
          className="p-4 mt-4"
          style={{
            background: "#fff",
            border: "1px solid #fff",
            borderRadius: "8px",
            boxShadow: "2px 2px 10px -1px #b9b3b3",
          }}
        >
          <p className="text-center">Enter your ID and Passcode</p>
          <input
            className="text-center"
            type="text"
            value={inputId}
            onChange={handleInputId}
            placeholder="Your ID"
          />
          <input
            className="text-center"
            type="text"
            value={inputPasscode}
            onChange={handleInputPasscode}
            placeholder="Your Passcode"
          />
          <div className="d-flex justify-content-center mt-4">
            <button
              className="border-0 text-center"
              onClick={handleButtonClick}
            >
              Show grades
            </button>
          </div>
          <div className="d-flex justify-content-center">
            <button className="border-0 mt-4" onClick={handleForgotPassword}>
              Forgot Passcode?
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
